
import { SimpleSVG } from 'vue-simple-svg'
export default {
  props: {
    tools: {
      type: Array,
      required: true
    },
    is_grid: {
      type: Boolean,
      required: true
    },
    is_round: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      svgLoaded: [],
      amount: 5
    }
  },
  methods: {
    pushSVGLoaded(idx) {
      // this.$set(this.svgLoaded, idx, true)
      this.svgLoaded.push('yes', idx)
    }
  },
  mounted() {
    // this.tools.forEach((tool) => {
    //   if (
    //     tool !== undefined &&
    //     tool.link !== undefined &&
    //     tool.link[0] !== undefined &&
    //     tool.link[0].icon !== undefined &&
    //     tool.link[0].icon[0] !== undefined &&
    //     tool.link[0].icon[0].icon !== undefined &&
    //     tool.link[0].icon[0].icon !== '' &&
    //     tool.link[0].color[0] !== undefined &&
    //     tool.link[0].color[0].color !== undefined
    //   ) {
    //     this.svgLoaded.push(false)
    //   } else {
    //     this.svgLoaded.push(true)
    //   }
    // })
    //document.documentElement.style.setProperty('--amount', this.tools.length)
  },
  components: {
    SimpleSVG
  }
}
